<template>
  <div>
    <!-- begin #header mobile -->
    <div id="header" class="header navbar-default">
      <!-- begin navbar-header -->
      <div class="navbar-header mobile-header">
        <button
          type="button"
          class="navbar-toggle mobile-menu-btn"
          @click.stop="drawer = !drawer"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>

        <router-link 
          v-if="this.admin === 'false'" 
          to="/app" 
          class="navbar-brand mobile-brand"
        >
          <img
            class="mobile-logo"
            src="/assets/img/solo_icono.png"
            alt=""
          />
          <span class="mobile-brand-text">
            <b>Mixora&nbsp;</b> - The Color System
          </span>
        </router-link>
        <router-link
          v-if="this.admin === 'true'"
          to="/Admin"
          class="navbar-brand mobile-brand"
        >
          <img
            class="mobile-logo"
            src="/assets/img/solo_icono.png"
            alt=""
          />
          <span class="mobile-brand-text">
            <b>Mixora&nbsp;</b> - The Color System
          </span>
        </router-link>

        <ul class="navbar-nav navbar-right mobile-user-nav">
          <b-nav-item-dropdown
            menu-class="dropdown-menu-right"
            class="dropdown navbar-user mobile-user"
            no-caret
          >
            <template slot="button-content">
              <img :src="foto" alt="" />
              <b class="caret"></b>
            </template>
            <b-dropdown-item @click.prevent="editPerfil">{{
              $t("actions.editProfile")
            }}</b-dropdown-item>
            <b-dropdown-item
              v-if="hasSisterProductLink && admin === 'false'"
              @click.prevent="goToSisterProduct"
            >
              {{ $t("landing.visitProduct", { product: sisterProductName }) }}
            </b-dropdown-item>
            <b-dropdown-item v-if="this.auth.Rol === 1" @click.prevent="goAdmin">
              Login Administrador
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item @click.prevent="cerrarSesion">{{
              $t("actions.closeSession")
            }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </ul>
      </div>
      <!-- end navbar-header -->
    </div>

    <v-navigation-drawer v-model="drawer" temporary fixed>
      <v-list nav tag="ul">
        <v-list-item-group
          v-model="group"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item tag="li"> </v-list-item>
          <v-list-item tag="li">
            <a href="#" @click.prevent="colorMix">
              <i class="fa fa-fill-drip"></i> Color Mix
            </a>
          </v-list-item>

          <v-list-item tag="li">
            <a href="#" @click.prevent="misFormulas">
              <i class="fa fa-palette"></i> {{ $t("nav.MyFormulas") }}</a
            >
          </v-list-item>

          <v-list-item tag="li">
            <a href="#" @click.prevent="misSugerencias">
              <i class="fa fa-message mr-1 mr-md-0"></i>
              {{ $t("nav.MySuggestions") }}</a
            >
          </v-list-item>

          <v-list-item tag="li">
            <a href="#" @click.prevent="misNotificaciones">
              <i class="fa fa-bell"></i> {{ $t("nav.Notifications") }}
            </a>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <!-- end #header mobile -->
  </div>
</template>

<script>
import PageOptions from "../../config/PageOptions.vue";
import MainService from "@/services/MainService.js";
import StorageMethods from "@/utils/StorageMethods.js";
import {
  resolveProductKey,
  resolveSisterProductKey,
  resolveSisterProductUrl,
} from "@/utils/productIdentity.js";

export default {
  name: "HeaderMobile",
  data() {
    let ss = new MainService();
    let storage = new StorageMethods();
    return {
      pageOptions: PageOptions,
      auth: {},
      ss: ss,
      storage: storage,
      admin: "false",
      drawer: false,
      foto: null,
    };
  },
  computed: {
    sisterProductUrl() {
      return resolveSisterProductUrl();
    },
    hasSisterProductLink() {
      return Boolean(this.sisterProductUrl);
    },
    sisterProductName() {
      const sisterKey = resolveSisterProductKey(resolveProductKey());
      return this.$t(`landing.products.${sisterKey}.shortName`);
    },
  },
  methods: {
    cerrarSesion() {
      let admin = localStorage.getItem("admin");
      this.storage.cleanSession();
      if (admin === "true") {
        this.$router.push("/Admin/Login");
      } else {
        this.$router.push("/Login");
      }
    },
    misFormulas() {
      this.drawer = false;
      this.$router.push("/MisFormulas");
    },
    colorMix() {
      this.drawer = false;
      this.$router.push("/app");
    },
    misSugerencias() {
      this.drawer = false;
      this.$router.push("/MisSugerencias");
    },
    misNotificaciones() {
      this.drawer = false;
      this.$router.push("/Notificaciones");
    },
    editPerfil() {
      if (this.admin === "true") {
        this.$router.push("/Admin/Profile");
      } else {
        this.$router.push("/Profile");
      }
    },
    goAdmin() {
      this.$router.push("/Admin/Login");
    },
    goToSisterProduct() {
      if (this.sisterProductUrl) {
        window.open(this.sisterProductUrl, "_blank", "noopener,noreferrer");
      }
    },
  },
  mounted() {
    this.auth = JSON.parse(localStorage.getItem("persona"));
    if (this.auth.Foto) {
      this.foto = this.auth.Foto;
    } else {
      this.foto = this.auth.URLFoto;
    }
    this.admin = localStorage.getItem("admin");
  },
};
</script>

<style scoped>
.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 50px;
  padding: 0 8px;
}

.mobile-menu-btn {
  margin: 0;
  padding: 8px 12px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.mobile-brand {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 4px 0;
  flex: 1;
  justify-content: center;
}

.mobile-logo {
  height: 24px;
  width: 24px;
  margin-right: 8px;
}

.mobile-brand-text {
  font-size: 14px;
}

.mobile-user-nav {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

.mobile-user {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

.mobile-user img {
  height: 32px;
  width: 32px;
}
</style>

